import type { HttpFetcherWithBaseUrl } from '../../../../shared/source/http-fetcher';
import type { HttpFetcherError } from '../../../../shared/source/http-fetcher/http-fetcher';
import type { Result } from 'true-myth';

export type SkillFetchers = {
    readonly changeSkillFeedback: (args: {
        readonly description: string;
        readonly skillId: string;
    }) => Promise<Result<unknown, HttpFetcherError>>;
    readonly reportSkillFeedback: (args: {
        readonly description: string;
        readonly skillId: string;
    }) => Promise<Result<unknown, HttpFetcherError>>;
    readonly requestSkillFeedback: (args: {
        readonly description: string;
        readonly title: string;
        readonly type?: string;
    }) => Promise<Result<unknown, HttpFetcherError>>;
};

export type FeedbackFetchersDependencies = {
    readonly cobrainerApiFetcher: HttpFetcherWithBaseUrl;
};

export const createSkillFetchers = (dependencies: FeedbackFetchersDependencies): SkillFetchers => {
    const { cobrainerApiFetcher } = dependencies;

    const requestSkillFeedback: SkillFetchers['requestSkillFeedback'] = async (payload) => {
        return cobrainerApiFetcher.postJson({
            pathname: `/skills/feedback/request-skill`,
            payload,
        });
    };

    const changeSkillFeedback: SkillFetchers['changeSkillFeedback'] = async (payload) => {
        return cobrainerApiFetcher.postJson({
            pathname: `/skills/feedback/change-skill`,
            payload,
        });
    };

    const reportSkillFeedback: SkillFetchers['reportSkillFeedback'] = async (payload) => {
        return cobrainerApiFetcher.postJson({
            pathname: `/skills/feedback/report-skill`,
            payload,
        });
    };

    return {
        changeSkillFeedback,
        reportSkillFeedback,
        requestSkillFeedback,
    };
};
